import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from '../../../shared/service/webapi.service';
import { BaseComponent } from 'src/app/shared/base/base.component';


@Component({
  selector: 'app-add-edit-proxy',
  templateUrl: './add-edit-proxy.component.html',
  styleUrls: ['./add-edit-proxy.component.scss']
})
export class AddEditProxyComponent extends BaseComponent implements OnInit {
  @Input() isAdd: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Output() close = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  @Output() Cancel = new EventEmitter<any>();

  validateForm: FormGroup;
  dateFormat = 'yyyy/MM/dd';
  loading: boolean = false;
  GetEmployeeEname: string;
  GetEmployeeDept: string;
  GetProxyEname: string;
  GetProxyDept: string;
  OldProxyID: string;
  OldStartDate: any;
  OldEndDate: any;
  pageIndex: number = 1;
  listOfData: any[] = [];
  pageSize: number = 20;
  isCancel: boolean = false;
  nzTotal: number = 0;
  listOfOption: string[] = [];
  children: string[] = ['交期維護', '對帳貨款管理', '.......'];
  listOfSelectedValue: string[] = [];
  forbid: boolean;
  ALLforbid: boolean;

  constructor(private authService: AuthService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private fb: FormBuilder,
    private EnvironmentconfigService: EnvironmentconfigService) { super(); }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      EmployeeID: [(this.authService.getCurrentUserInfo()?.userId ?? ''), [Validators.required]],
      ProxyID: ['', [Validators.required]],
      StartDate: ['', [Validators.required]],
      EndDate: ['', [Validators.required]],
      Remark: [''],
      PoNo: [''],
      selectfunction: this.listOfSelectedValue
    });
    this.IDChange('Employee');

    if (this.editData) {
      this.validateForm.controls['EmployeeID'].setValue(this.editData['employeeID']);
      this.validateForm.controls['ProxyID'].setValue(this.editData['proxyID']);
      this.validateForm.controls['PoNo'].setValue(this.editData['pono']);
      this.validateForm.controls['StartDate'].setValue(this.editData['startDate']);
      this.validateForm.controls['EndDate'].setValue(this.editData['endDate']);
      this.validateForm.controls['Remark'].setValue(this.editData['remark']);
      this.validateForm.controls['selectfunction'].setValue(this.editData['對帳貨款管理,交期維護']);

      this.OldProxyID = this.editData['proxyID'];
      this.OldStartDate = this.editData['startDate'];
      this.OldEndDate = this.editData['endDate'];
      this.IDChange('Proxy');
    }

    if (this.isEdit) {
      this.validateForm.controls['EmployeeID'].disable();
      this.validateForm.controls['PoNo'].disable();
    }

    this.listOfOption = this.children;
    this.forbid = false;

  }

  onClose(): void {
    this.close.emit();
    if (!this.isEdit) {
      this.resetForm();
    }
  }

  resetForm(): void {
    this.validateForm.reset();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsPristine();
      this.validateForm.controls[key].updateValueAndValidity();
    }
  }

  submitForm = ($event: any, value: any) => {
    $event.preventDefault();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    let obj = {};
    obj['StartDate'] =
      this.getTheDateString_(this.validateForm.controls['StartDate'].value) ||
      '';
    obj['EndDate'] =
      this.getTheDateString_(this.validateForm.controls['EndDate'].value) || '';
    obj['EmployeeID'] = this.validateForm.controls['EmployeeID'].value;
    obj['ProxyID'] = this.validateForm.controls['ProxyID'].value;
    obj['Remark'] =
      this.validateForm.controls['Remark'].value == null
        ? ''
        : this.validateForm.controls['Remark'].value;
    obj['OldProxyID'] = this.OldProxyID;
    obj['OldStartDate'] = this.getTheDateString_(this.OldStartDate);
    obj['OldEndDate'] = this.getTheDateString_(this.OldEndDate);
    obj['PoNo'] = this.validateForm.controls['PoNo'].value;
    obj['Function'] = "對帳貨款管理,交期維護";

    if (!this.isCancel) {
      this.save.emit(obj);
    }
    else {
      this.Cancel.emit(obj);
    }
  };

  IDChange(flag) {
    this.loading = true;
    let value = flag == 'Employee' ? this.validateForm.controls['EmployeeID'].value : this.validateForm.controls['ProxyID'].value;
    const params = 'buyer=' + value;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetNameDept.url}`;
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
          if (flag == 'Employee') {
            this.GetEmployeeEname = res.data ? res.data.ename : '';
            this.GetEmployeeDept = res.data ? res.data.dept : '';
          }
          if (flag == 'Proxy') {
            this.GetProxyEname = res.data ? res.data.ename : '';
            this.GetProxyDept = res.data ? res.data.dept : '';
          }
        } else {
          this.messageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  RemarkLengthFilter(event, key: string) {
    if (event && event.length > 350) {
      event = event.slice(0, 350);
      this.validateForm.controls[key].setValue(
        event.slice(0, 350)
      );
    }
  }

  cancelProxy() {
    this.isCancel = true;
  }

  // isNotSelected(value)
  // { 
  //   if(value == 'All')
  //   {
  //   }


  // }

  // getvalue(data)
  // {
  //   if(data=='ALL')
  //   {
  //     this.ALLforbid=false;
  //     this.forbid=true;
  //   }
  //   else if(data=='')
  //   {
  //     this.ALLforbid=false;
  //     this.forbid=false;
  //   }
  //   else
  //   {
  //     this.ALLforbid=true;
  //     this.forbid=false;
  //     this.validateForm.controls['selectfunction'].setValue(data);
  //   }
  // }

}
